import { NavLink } from "react-router-dom";

const MenuItem = ({ link, title, activeLink, onClick, pathName }) => {

  return   (
        <li
          onClick={onClick}
          className={`hover:text-purple-500 mx-2 font-nunito sm:text-lg font-bold`}
        >
            <NavLink to={link} className={`${activeLink === title ? "underline" : ""}`}>
              {title}
            </NavLink>
            <div className="hidden sm:flex justify-center">
            <div className={`${pathName === link ? "bg-purpleCustom h-1 w-1/2" : ""}`}  />
            </div>
      </li>
      )


}




export default MenuItem;